export const DOCUMENT_TYPE_PAGE = 'page';
export const DOCUMENT_TYPE_FRONTPAGE = 'frontpage';
export const DOCUMENT_TYPE_CATEGORY = 'category';
export const DOCUMENT_TYPE_ARTICLE = 'article';
export const DOCUMENT_TYPE_ARTICLE_365 = 'article365';
